/** Read fetch inputs once, preserving RequestInit overrides and Request-owned signals. */
export function getFetchInputUrl(input: RequestInfo | URL): string {
  if (typeof input === 'string') return input
  return typeof Request !== 'undefined' && input instanceof Request ? input.url : input.toString()
}

export function getFetchRequestSignal(input: RequestInfo | URL, init?: RequestInit): AbortSignal | null | undefined {
  if (init?.signal !== undefined) return init.signal
  return typeof Request !== 'undefined' && input instanceof Request ? input.signal : undefined
}
